import { css, Interpolation } from '@emotion/react'
import { Theme } from './theme'

export const globalStyles: Interpolation<Theme> = theme => css`
  html {
    font-size: 6px;

    @media ${theme.breakpoints.sm} {
      font-size: 10px;
    }

    @media ${theme.breakpoints.md} {
      font-size: 6px;
    }

    @media ${theme.breakpoints.lg} {
      font-size: 7px;
    }
  }

  body {
    font-family: ${theme.fonts.default};
    font-size: ${theme.fontSizes.body1};
    font-weight: ${theme.fontWeights.medium};
    letter-spacing: ${theme.letterSpacings.normal};
    color: ${theme.colors.black};
    background-color: ${theme.colors.white};
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    font-size: inherit;
    color: inherit;
    background: unset;
    border: unset;
    padding: unset;
    outline: 0;
  }

  input,
  select,
  textarea {
    border: unset;
    font-size: inherit;
    box-sizing: border-box;
  }

  select {
    appearance: none;
  }
  select::-ms-expand {
    display: none;
  }
`
